// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA96qwP3THYEt2M8v8IRbBurshVLKqJjV8",
  authDomain: "urbancafe-demo.firebaseapp.com",
  projectId: "urbancafe-demo",
  storageBucket: "urbancafe-demo.firebasestorage.app",
  messagingSenderId: "244222885889",
  appId: "1:244222885889:web:26e1a6b68b940337188000"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };